export const fullNameValidator = (fullName: string): boolean => {
	if (!fullName) return false;
	const words = fullName.trim().split(/\s+/);
	return words.length >= 2 && words.every((word) => word.length > 0);
};

export const emailValidator = (email: string): boolean => {
	const MATCH_EMAIL_REGEX = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	const textMatch = email.match(MATCH_EMAIL_REGEX);
	return textMatch !== null;
};
